import { ComponentPropsWithoutRef, forwardRef, MouseEvent } from 'react';
import cn from 'classnames';

type Props = {
  selected?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
} & ComponentPropsWithoutRef<'li'>;

const LNBAccountSearchtItem = forwardRef<HTMLLIElement, Props>(
  ({ selected = false, onClick, children, ...props }, ref) => {
    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      onClick?.(e);
    };

    return (
      <li {...props} ref={ref} className={cn({ on: selected })}>
        <a href="#none" className="link_option" onClick={handleClick}>
          {children}
        </a>
      </li>
    );
  }
);

LNBAccountSearchtItem.displayName = 'LNBAccountSearchtItem';

export default LNBAccountSearchtItem;
